var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncidentMisReportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 73,
    viewBox: "0 0 59 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "039---Error-Report"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M42.0861 5.0332H53.4136C56.194 5.0332 58.448 7.28719 58.448 10.0676V67.9635C58.448 70.7439 56.194 72.9979 53.4136 72.9979H5.58655C2.80611 72.9979 0.552124 70.7439 0.552124 67.9635V10.0676C0.552124 7.28719 2.80611 5.0332 5.58655 5.0332H42.0861Z",
    fill: "#E64C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M41.7463 10.0684H52.155C52.8501 10.0684 53.4136 10.6319 53.4136 11.327V66.7056C53.4136 67.4007 52.8501 67.9642 52.155 67.9642H6.84515C6.15004 67.9642 5.58655 67.4007 5.58655 66.7056V11.327C5.58655 10.6319 6.15004 10.0684 6.84515 10.0684H41.7463Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M41.7966 41.5338H17.2198C16.1973 41.5343 15.2559 40.9776 14.7637 40.0813C14.2716 39.1851 14.307 38.0919 14.8561 37.2294L27.412 17.5121C27.8684 16.7959 28.6589 16.3623 29.5082 16.3623C30.3575 16.3623 31.148 16.7959 31.6044 17.5121L44.1603 37.2294C44.7094 38.0919 44.7448 39.1851 44.2527 40.0813C43.7605 40.9776 42.8191 41.5343 41.7966 41.5338Z",
    fill: "#E64C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M29.5001 37.7584C30.1952 37.7584 30.7587 37.1949 30.7587 36.4998C30.7587 35.8047 30.1952 35.2412 29.5001 35.2412C28.805 35.2412 28.2415 35.8047 28.2415 36.4998C28.2415 37.1949 28.805 37.7584 29.5001 37.7584Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M29.5001 32.7231C28.805 32.7231 28.2415 32.1596 28.2415 31.4645V23.9129C28.2415 23.2178 28.805 22.6543 29.5001 22.6543C30.1952 22.6543 30.7587 23.2178 30.7587 23.9129V31.4645C30.7587 32.1596 30.1952 32.7231 29.5001 32.7231Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    d: "M34.5345 50.3444H11.8796C11.1845 50.3444 10.621 49.7809 10.621 49.0858C10.621 48.3906 11.1845 47.8271 11.8796 47.8271H34.5345C35.2296 47.8271 35.7931 48.3906 35.7931 49.0858C35.7931 49.7809 35.2296 50.3444 34.5345 50.3444Z",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    d: "M43.3446 51.6028C43.0109 51.6027 42.6908 51.47 42.4548 51.234L41.1962 49.9754C40.7192 49.4815 40.726 48.6965 41.2115 48.211C41.697 47.7256 42.482 47.7187 42.9759 48.1957L43.3446 48.5645L46.2306 45.6785C46.7245 45.2015 47.5095 45.2083 47.995 45.6938C48.4804 46.1793 48.4873 46.9643 48.0103 47.4582L44.2345 51.234C43.9985 51.47 43.6784 51.6027 43.3446 51.6028Z",
    fill: "#4FBA6F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    d: "M34.5345 60.4127H11.8796C11.1845 60.4127 10.621 59.8492 10.621 59.1541C10.621 58.459 11.1845 57.8955 11.8796 57.8955H34.5345C35.2296 57.8955 35.7931 58.459 35.7931 59.1541C35.7931 59.8492 35.2296 60.4127 34.5345 60.4127Z",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8",
    d: "M43.3446 61.6711C43.0109 61.671 42.6908 61.5384 42.4548 61.3023L41.1962 60.0437C40.7192 59.5499 40.726 58.7649 41.2115 58.2794C41.697 57.7939 42.482 57.7871 42.9759 58.2641L43.3446 58.6328L46.2306 55.7469C46.7245 55.2699 47.5095 55.2767 47.995 55.7622C48.4804 56.2477 48.4873 57.0327 48.0103 57.5265L44.2345 61.3023C43.9985 61.5384 43.6784 61.671 43.3446 61.6711Z",
    fill: "#4FBA6F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9",
    d: "M42.0861 5.03377V8.80959C42.0861 10.1998 40.9591 11.3268 39.5688 11.3268H19.4312C18.0409 11.3268 16.9139 10.1998 16.9139 8.80959V5.03377C16.9139 3.64355 18.0409 2.51656 19.4312 2.51656H23.8791C24.6222 2.49854 25.3236 2.16929 25.8123 1.60911C26.7648 0.584221 28.1008 0.00195312 29.5 0.00195312C30.8992 0.00195312 32.2352 0.584221 33.1877 1.60911C33.6764 2.16929 34.3778 2.49854 35.1209 2.51656H39.5688C40.9591 2.51656 42.0861 3.64355 42.0861 5.03377Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M29.5001 6.2926C30.1952 6.2926 30.7587 5.7291 30.7587 5.034C30.7587 4.33889 30.1952 3.77539 29.5001 3.77539C28.805 3.77539 28.2415 4.33889 28.2415 5.034C28.2415 5.7291 28.805 6.2926 29.5001 6.2926Z",
    fill: "#7F8C8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentMisReportIcon);
export default __webpack_public_path__ + "static/media/IncidentMisReportIcon.e4f1812e98ac1fc0ae52a6b06fb57e36.svg";
export { ForwardRef as ReactComponent };